import get from 'transmute/get';
import { createSelector } from 'reselect';
import { getUser } from './getUser';
export const getFirstName = createSelector(getUser, get('first_name'));